import { ComplainantTraffic } from "../Model/ComplainantTraffic";
import { Query } from "../Model/Query";
import { Third } from "../Model/Third";
import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
export class ComplainantTrafficService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(thirdId, diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('complainant/traffic/' + diligenceId + '/third_id/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ComplainantId`);
        }
    }
    async findByDiligenceNumber(diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('complainant/traffic/' + diligenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ComplainantId`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`complainants/trafficThirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveComplainantTraffic(complainantTraffic) {
        const response = await this.apiService.post('complainant_traffic', complainantTraffic);
        if (!response.ok) {
            throw new Error(`Error al guardar el extra de diligencia trafico`);
        }
        return true;
    }
    async createComplainantTraffic(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const third = new ComplainantTraffic({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                complainantThirId: thirdId,
                vehicle_id: null,
                vehicle_damage: 'no',
                trailer_registration: 'no',
                time_p_alcohol1: null,
                result_p_alcohol1: null,
                time_p_alcohol2: null,
                result_p_alcohol2: null,
                urine_blood_extraction: false,
                optional_part: 'no',
                medical_history: 'no',
                exceeds_060: false,
                low_influence: false,
                physical_defects: false,
                perform_alcoholemia: false,
                administrative_infection: false,
                complaint: false,
                num_boletin: null,
                user_id: getCurrentUser().id,
                want_declare: false,
                family_notice: false,
                medical_examination: false,
                interpreter: false,
                appoints_lawyer: false,
                ex_officio: false,
                external_aspect_id: null,
                physical_constitution_id: null,
                dress_id: null,
                face_id: null,
                look_id: null,
                pupils_id: null,
                voice_id: null,
                respiration_id: null,
                movements_id: null,
                ask_react_id: null,
                others_detalles_id: null,
                behavior_id: null,
                driving_license: false,
                license_expiration: null
            });
            const response = await this.apiService.post('complainant_traffic', third.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de una diligencia trafico`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante`);
        }
    }
    async deleteComplainantTraffic(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('complainants_traffic/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el denunciante de una diligencia trafico.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante.`);
        }
    }
}
